import { useParams } from 'react-router-dom';
import PageHeader from '../components/shared/PageHeader';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import Table from '../components/ui/Table';
import { currency, distance } from '../utils/formatters';
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { getOficinaId } from '../lib/office';
import { useAuth } from '../hooks/useAuth';

export default function DetalhesCliente() {
  const { id } = useParams();
  const { perfil } = useAuth();
  const canViewFinance = perfil?.perfil === 'admin';
  const [cliente, setCliente] = useState(null);
  const [veiculos, setVeiculos] = useState([]);
  const [ordens, setOrdens] = useState([]);
  const [mecanicos, setMecanicos] = useState([]);

  useEffect(() => {
    const load = async () => {
      const oficinaId = await getOficinaId();
      if (!oficinaId) return;
      const [c, v, o, m] = await Promise.all([
        supabase.from('clientes').select('*').eq('id', id).eq('oficina_id', oficinaId).is('removed_at', null).maybeSingle(),
        supabase.from('veiculos').select('*').eq('cliente_id', id).eq('oficina_id', oficinaId).is('removed_at', null),
        supabase.from('ordens_servico').select('*').eq('cliente_id', id).eq('oficina_id', oficinaId),
        supabase.from('usuarios').select('id,nome').eq('oficina_id', oficinaId),
      ]);
      setCliente(c.data || null);
      setVeiculos(v.data || []);
      setOrdens(o.data || []);
      setMecanicos(m.data || []);
    };
    load();
  }, [id]);

  if (!cliente) {
    return <Card><p className="text-sm text-zinc-400">Cliente não encontrado.</p></Card>;
  }

  return (
    <div className="space-y-4">
      <PageHeader title={cliente.nome} subtitle={`${cliente.telefone} • ${cliente.email}`} />
      <div className="grid gap-3 md:grid-cols-3">
        <Card><p className="text-xs text-zinc-400">CPF</p><p>{cliente.cpf}</p></Card>
        <Card><p className="text-xs text-zinc-400">Veículos</p><p className="font-display text-3xl">{veiculos.length}</p></Card>
        {canViewFinance && <Card><p className="text-xs text-zinc-400">Total gasto</p><p className="font-display text-3xl text-success">{currency((ordens || []).reduce((acc, o) => acc + Number(o.valor_total || 0), 0))}</p></Card>}
      </div>

      <Card>
        <h3 className="mb-2 font-semibold">Veículos cadastrados</h3>
        <div className="grid gap-2 md:grid-cols-2">
          {(veiculos || []).map((v) => (
            <div key={v.id} className="rounded-lg bg-surface2 p-3 text-sm">
              <p className="font-semibold">{v.marca} {v.modelo}</p>
              <p className="text-zinc-400">{v.placa} • {v.ano} • {distance(v.km_atual || v.km || 0)}</p>
            </div>
          ))}
        </div>
      </Card>

      <Card>
        <h3 className="mb-2 font-semibold">Histórico completo de OS</h3>
        <Table
          columns={['Número', 'Status', 'Mecânico', ...(canViewFinance ? ['Valor'] : [])]}
          rows={ordens}
          renderRow={(o) => (
            <tr key={o.id} className="border-t border-border hover:bg-surface2">
              <td className="px-3 py-2">{o.numero}</td>
              <td className="px-3 py-2"><Badge>{o.status}</Badge></td>
              <td className="px-3 py-2">{mecanicos.find((m) => m.id === o.mecanico_id)?.nome}</td>
              {canViewFinance && <td className="px-3 py-2">{currency(o.valor_total)}</td>}
            </tr>
          )}
        />
      </Card>
    </div>
  );
}
